import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=608bdfbf&scoped=true&"
import script from "./parameter.vue?vue&type=script&lang=js&"
export * from "./parameter.vue?vue&type=script&lang=js&"
import style0 from "./parameter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./parameter.vue?vue&type=style&index=1&id=608bdfbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608bdfbf",
  null
  
)

export default component.exports